<div class="container-requests">
  <div class="container-breadcrumb">
    <p id="id-breadcrumb-3" class="copec-lg-14">
      Admin / <span class="ruta"> Gestor de solicitudes /</span>
    </p>
  </div>
  <div class="box-title-request">
    <div class="copec-bold-25 mb-3">Gestor de solicitudes</div>
    <div class="box-user-resp">
      <span class="copec-lg-12">Persona a cargo</span>
      <span class="copec-rg-14">{{ name }}</span>
    </div>
  </div>
  <div>
    <div class="mb-3">
      <span class="copec-rg-16">Resumen</span>
    </div>
    <div class="container-resumen">
      <div
        *ngFor="let item of summaryItems"
        class="box-resumen"
        [ngClass]="{ 'selected-box-resumen': filterLabel === item.label }"
        (click)="filterByLabel(item.label)"
      >
        <div>
          <span class="copec-bold-14 mb-2">{{ item.label }}</span>
        </div>
        <div>
          <span class="number copec-bold-16">{{ item.value }}</span>
          <span class="total copec-lg-14">{{ item.description }}</span>
        </div>
      </div>
    </div>

    <div>
      <div class="container-request">
        <div class="search-requests">
          <i class="fa-solid fa-lg fa-magnifying-glass"></i>
          <input
            class="input-requests"
            maxlength="70"
            type="text"
            placeholder="Buscar solicitud"
            (input)="onSearch()"
            [(ngModel)]="searchTerm"
            #input
          />
        </div>

        <div class="mt-2">
          <table
            mat-table
            [dataSource]="paginatedRequests"
            multiTemplateDataRows
            class="mat-elevation-z8"
            aria-label="Tab Solicitudes"
          >
            <ng-container
              *ngFor="let column of columnsToDisplay; trackBy: trackByFn"
            >
              <ng-container *ngIf="column !== 'chip'" matColumnDef="{{ column }}">
                <th mat-header-cell *matHeaderCellDef class="copec-bold-16">
                  {{ writeColumn(column) }}
                </th>
                <td mat-cell *matCellDef="let element" class="copec-rg-16">
                  {{ element[column] }}
                </td>
              </ng-container>
              <ng-container *ngIf="column === 'chip'" matColumnDef="chip">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element">    
                  <img [src]="getIconStatus(element.status)" alt="" [ngStyle]="element.status != 'Rechazada' ? {'width': '88px'} : {}"/>
                </td>
              </ng-container>
            </ng-container>

            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef aria-label="row actions">
                &nbsp;
              </th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-icon-button
                  aria-label="expand row"
                  (click)="
                    expandedElement =
                      expandedElement === element ? null : element;
                    $event.stopPropagation()
                  "
                >
                  <mat-icon>{{
                    expandedElement === element
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"
                  }}</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
              <td
                mat-cell
                *matCellDef="let element"
                [attr.colspan]="columnsToDisplayWithExpand.length"
              >
                <div
                  class="example-element-detail"
                  [@detailExpand]="
                    element === expandedElement ? 'expanded' : 'collapsed'
                  "
                >
                  <app-benefit-detail
                    [dataBenefit]="element"
                    [idElement]="element.idCode"
                  ></app-benefit-detail>
                </div>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="columnsToDisplayWithExpand"
            ></tr>
            <tr
              mat-row
              *matRowDef="let element; columns: columnsToDisplayWithExpand"
              class="example-element-row"
              [class.example-expanded-row]="expandedElement === element"
              (click)="
                expandedElement = expandedElement === element ? null : element
              "
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: ['expandedDetail']"
              class="example-detail-row"
            ></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="7">
                No hay datos que coincidan con el filtro "{{ input.value }}"
              </td>
            </tr>
          </table>

          <div class="container-paginated">
            <div class="mostrandoPage">
              <span id="pag-span-1" *ngIf="isSizeMobile">
                {{ currentPage }} de {{ totalPages }}</span
              >
              <span id="pag-span-2" *ngIf="!isSizeMobile"
                >Mostrando {{ currentPage }} de {{ totalPages }}
              </span>
            </div>
            <div class="mostrandoPage2">
              <span id="pag-span-2" *ngIf="!isSizeMobile">
                Tabla por página:</span
              >
            </div>
            <div>
              <select (click)="onSelecPageChange($event)" class="nregistros">
                <option value="15">15</option>
                <option value="10">10</option>
                <option value="5">5</option>
              </select>
            </div>
            <div>
              <app-paginator-select
                id="ben-app-4"
                [currentPage]="currentPage"
                [totalPages]="totalPages"
                (pageChange)="onPageChange($event)"
              ></app-paginator-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
